import React from "react";
import { useNavigate } from "react-router-dom";
import {
  MdImage,
  MdCheckCircle,
  MdWarning,
} from "react-icons/md";

import { useGetQuizImageStatusQuery } from "../../slices/quizImageApiSlice";

const QuizImageStatusCard = ({ quizId }) => {
  const navigate = useNavigate();

  const { data, isLoading, isError } = useGetQuizImageStatusQuery(quizId, {
    skip: !quizId,
  });

  if (isLoading) {
    return (
      <div className="mb-4 rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
        <div className="flex justify-center">
          <svg
            className="h-8 w-8 animate-spin text-blue-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="mb-4 rounded-xl border border-red-200 bg-red-50 p-4 shadow-sm">
        <p className="text-red-600">
          Failed to load quiz image status.
        </p>
      </div>
    );
  }

  const quiz = data?.data;

  if (!quiz) {
    return null;
  }

  return (
    <div className="mb-4 rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">
            {quiz.name}
          </h2>

          <div className="mt-3 flex flex-wrap items-center gap-3">
            <div className="flex items-center gap-2 text-gray-600">
              <MdImage className="text-xl text-blue-600" />
              <span className="text-sm font-medium">
                Image Questions
              </span>
            </div>

            {quiz.hasImageQuestions ? (
              <span className="inline-flex items-center gap-1 rounded-full bg-green-100 px-3 py-1 text-sm font-medium text-green-700">
                <MdCheckCircle />
                Required
              </span>
            ) : (
              <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-3 py-1 text-sm font-medium text-gray-700">
                <MdWarning />
                Not Required
              </span>
            )}
          </div>
        </div>

        {quiz.hasImageQuestions && (
          <button
            onClick={() => navigate(`/quizzes/${quiz._id}/images`)}
            className="inline-flex items-center gap-2 rounded-lg bg-purple-600 px-5 py-2.5 font-medium text-white transition hover:bg-purple-700"
          >
            <MdImage className="text-lg" />
            Manage Images
          </button>
        )}
      </div>
    </div>
  );
};

export default QuizImageStatusCard;